var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarth24 = function SvgEarth24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-8a8 8 0 0 0-7.938 9.002c.077.005.155.018.232.042l2.87.883a1 1 0 0 0 1.249-1.254l-.556-1.778A3 3 0 0 1 10.72 7h1.718a1 1 0 0 0 .97-.757l.504-2.013A8.02 8.02 0 0 0 12 4Zm3.792.954-.443 1.774A3 3 0 0 1 12.439 9H10.72a1 1 0 0 0-.954 1.298l.556 1.779c.72 2.304-1.438 4.472-3.746 3.762l-1.884-.58a8.002 8.002 0 0 0 10.803 3.94l-.748-.5c-1.87-1.246-1.63-4.067.424-4.98a.853.853 0 0 0 .481-.987l-.233-.933a3 3 0 0 1 1.569-3.41l1.665-.833a8.039 8.039 0 0 0-2.86-2.602ZM20 12a7.98 7.98 0 0 1-2.704 5.996l-1.44-.96a.853.853 0 0 1 .127-1.49 2.853 2.853 0 0 0 1.61-3.3l-.234-.932a1 1 0 0 1 .523-1.137l1.666-.833c.293.83.452 1.725.452 2.656Z",
    fill: "currentColor"
  })));
};
export default SvgEarth24;